import React from 'react';
import * as _ from 'lodash';
import { FieldTreeService } from '../../../services/FieldTrees';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FieldTreeAllCompaniesDropdownRadio } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import debounce from 'lodash.debounce';

/**
 * @description 管理会社ドロップダウン
 *              機材マスタ登録、編集画面で使用
 */
export class FieldTreeAllCompaniesDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      loaded: false, // ページング用ロードフラグ
      opened: false, // 開閉フラグ
      selected: {}, // 選択管理会社情報
      selectedName: '', // 選択管理会社情報(name)
      options: [], // 取得管理会社情報
      // 検索条件機材名
      condition: {
        name: '',
      },
      // ラジオボタンチェック用管理会社情報
      checked: {
        company_branch_id: null,
        field_tree_id: null,
      },
      isLoading: true, // ロード中フラグ
    };

    this.initializeLoaded = false; // 編集画面用初回ロードフラグ

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-branch-id-${this.id}`; // スクロールロード用ID
    this.search = this.search.bind(this); // 検索
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.setCondition = this.setCondition.bind(this); // 検索条件をセット
    this.setConditionDebounce = _.debounce(this.setCondition, 500).bind(this); // 遅延で検索条件をセットするための関数
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリック
    this.selectCompany = this.selectCompany.bind(this); // 管理会社選択
    this.getBranches = this.getBranches.bind(this); // 管理会社情報取
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
  }

  componentDidMount() {
    this.getBranches(() => {});
  }

  componentDidUpdate() {
    const prevState = arguments[1];
    if (this.state.opened) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!_.isEqual(this.state.condition, prevState.condition)) {
      this.search();
    }
  }

  componentWillReceiveProps(nextProps) {
    // 初期値が設定されていた場合はselectedへセット
    if (
      this.props.isEdit &&
      nextProps.value !== this.state.selected &&
      !_.isEmpty(nextProps.defaultName) &&
      this.initializeLoaded === false
    ) {
      this.initializeLoaded = true;
      let { checked, fieldId } = { ...this.state };
      checked.company_branch_id = nextProps.value || null;
      checked.field_tree_id = nextProps.field_tree_id || null;
      checked = { ...checked, ...nextProps.params };
      // company_branch_idとfield_tree_idを指定して、対象のcompany_nameを取得する
      FieldTreeService.allCompanies(fieldId, checked).then(response => {
        if (response.result === false) {
          return;
        }

        // 管理会社は複数指定不可の為、最初の会社情報のみ取得する
        const companiesData = response.data.entities.companies[0];
        this.setState({
          checked,
          selected: checked,
          selectedName: companiesData.name || '',
        });
      });
    }
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
    // フォーカスアウト時のバリデーション
    this.props.validate(this.props.name);
  };

  /**
   * @description ドロップダウンの開閉状態を設定
   */
  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
    if (this.state.opened) {
      // 選択ボタン押下時のバリデーション
      this.props.validate(this.props.name);
    }
  };

  /**
   * 検索条件をstateに反映する
   * @param {object} condition stateに反映する検索条件
   */
  changeCondition = events => {
    const { condition } = _.cloneDeep(this.state);
    condition.name = events.target.value;
    this.setConditionDebounce(condition);
  };

  /**
   * @description 検索する管理会社名を設定
   * @param {string} events 管理会社名 協力会社名input
   */
  setCondition = condition => {
    this.setState({ condition });
  };

  /**
   * @description 管理会社を検索
   */
  search = () => {
    let { options, loaded } = { ...this.state };
    options = [];
    loaded = false;

    this.getBranches(() => {}, { options, loaded });
    this.setState({ options, loaded, isLoading: true });
  };

  /**
   * @description ラジオボタンチェック
   * @param {object} option 選択された会社
   * @param {object} columns 同一会社判定に使用するカラム名配列
   */
  handleSelectedRow = (option, columns) => {
    // 全columnsの値が等しい会社を選択
    const checked = _.find(this.state.options, company => {
      for (let index in columns) {
        if (company[columns[index]] !== option[columns[index]]) {
          return false;
        }
      }
      return true;
    });
    this.setState({ checked }, () => {
      this.selectCompany(checked);
    });
  };

  /**
   * @description 管理会社選択
   * @param {object} checked 管理会社情報
   */
  selectCompany = checked => {
    if (!checked.name) {
      this.props.validate(this.props.name);
      this.setState({ opened: false });
      return;
    }
    this.props.set(
      this.props.setkey,
      checked.company_branch_id,
      checked.field_tree_id
    );
    // 選択ボタン押下時のバリデーション
    this.setState({
      selected: checked,
      selectedName: checked.name,
      opened: false,
    });
  };

  /**
   * @description 管理会社情報取得
   * @param {*} notify
   * @param {object} init 再読み込み設定
   *                      検索管理会社名を設定時に使用
   */
  getBranches(notify, init = {}) {
    const loaded = _.isEmpty(init) ? this.state.loaded : init.loaded;
    const options = _.isEmpty(init) ? [...this.state.options] : init.options;

    if (loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(options),
      name: this.state.condition.name,
    };

    FieldTreeService.allCompanies(this.state.fieldId, params).then(response => {
      if (response.result) {
        const branches = response.data.entities.companies;
        if (_.isEmpty(branches)) {
          this.setState({ loaded: true });
        } else {
          let companies = options;
          _.each(branches, branch => {
            companies.push(branch);
          });
          this.setState({
            options: companies,
            loaded: false,
          });
        }
        this.setState({ isLoading: false });
        notify();
      }
    });
  }

  render() {
    const { checked, selected, selectedName, options, opened } = this.state;
    const getName = () => {
      let name = '管理会社を選択';
      if (_.has(selected, 'field_tree_id')) {
        return selectedName || name;
      }
      const option =
        selected.field_tree_id === null
          ? _.find(options, {
              company_branch_id: selected.company_branch_id,
            })
          : _.find(options, {
              field_tree_id: selected.field_tree_id,
            });
      if (!_.isUndefined(option)) {
        name = option.name;
      } else {
        name = selectedName || name;
      }

      return name;
    };
    if (this.props.readOnly) {
      return <span>{getName()}</span>;
    }
    return (
      <div
        id='form-dropdown'
        className='dropdown-multi-select'
        onKeyPress={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        ref={this.parent}
      >
        <div
          className={
            opened
              ? 'dropdown-multi-select__header show'
              : 'dropdown-multi-select__header'
          }
        >
          <div
            id='form-dropdown-btn'
            className='dropdown-select'
            onClick={() => this.handleOpen()}
          >
            <span className='dropdown-select__txt'>{getName()}</span>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </div>
        </div>
        {this.state.opened && (
          <div
            id='form-dropdown-list'
            className='dropdown dropdown--dropdown-list show'
          >
            <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  defaultValue={this.state.condition.name}
                  onChange={this.changeCondition}
                />
              </div>
              <div className='dropdown-single-select__item'>
                <div
                  className='dropdown-single-select__scroll'
                  id={this.targetId}
                >
                  <ul className='single-select'>
                    {_.map(options, (option, index) => (
                      <FieldTreeAllCompaniesDropdownRadio
                        key={index}
                        indexKey={index}
                        option={option}
                        checked={
                          checked.field_tree_id == option.field_tree_id &&
                          checked.company_branch_id === option.company_branch_id
                        }
                        // メイン元請、JVサブ元請、全協力会社間で一意なID
                        targetId={
                          option.company_branch_id + option.field_tree_id
                        }
                        handleSelectedRow={this.handleSelectedRow}
                        forId='single-field-tree-operatable-id'
                        // company_branch_id：メインとJVサブの区別に必要
                        // field_tree_id    ：複数登録された協力会社の区別に必要
                        columns={['company_branch_id', 'field_tree_id']}
                      >
                        {option.name}
                      </FieldTreeAllCompaniesDropdownRadio>
                    ))}

                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(options)}
                      isLoading={this.state.isLoading}
                      callback={this.getBranches}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='form-list__alert show'>{this.props.error}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreeAllCompanies.jsx